import React from 'react';
import SkinComponent from './skins';
import { useShareablesTemplateRoot } from '../../hooks/useShareablesTemplateRoot';

export default function MyListingShareable(props) {
    const {
        rootClasses: classes,
        parsedData,
        currentFrame,
        onImagesLoaded,
    } = useShareablesTemplateRoot(props);
    if(!parsedData) return null;
    const {
        skin = props.skin || null,
    } = parsedData;

    return (
        <>
            <div className={classes.root} id="templateRoot">
                <div className={classes.viewport}>
                    <SkinComponent
                        skin={skin}
                        templateContent={parsedData}
                        currentFrame={currentFrame}
                        onImagesLoaded={onImagesLoaded}
                    />
                </div>
            </div>
        </>
    );
}
